import { render, staticRenderFns } from "./LibraryMemberEdit.vue?vue&type=template&id=2fa2928d"
import script from "../../controllers/library_member/library-member-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/library_member/library-member-edit.js?vue&type=script&lang=js&external"
import style0 from "./LibraryMemberEdit.vue?vue&type=style&index=0&id=2fa2928d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports